import { useState } from "react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "./ui/card";
import { Button } from "./ui/button";
import { Badge } from "./ui/badge";
import { Mail, Calendar, Users, Plus } from "lucide-react";

// Toggle this to switch between mock data (true) and real backend (false)
const USE_MOCK_DATA = true;

const CampaignsList = () => {
  const [campaigns] = useState(() => {
    return JSON.parse(localStorage.getItem("campaigns") || "[]");
  });

  const handleCreateCampaign = () => {
    if (USE_MOCK_DATA) {
      alert('Navigate to Create Campaign to create a new campaign');
    } else {
      // TODO: Navigate to Create Campaign page via backend
      alert('Backend API not yet available. Enable USE_MOCK_DATA for demo mode.');
    }
  };

  const handleCampaignClick = (campaignId: number) => {
    if (USE_MOCK_DATA) {
      alert(`Campaign details view not yet implemented. Campaign ID: ${campaignId}`);
    } else {
      // TODO: Navigate to campaign details page
      alert('Backend API not yet available. Enable USE_MOCK_DATA for demo mode.');
    }
  };

  return (
    <div className="space-y-6 p-6">
      <div className="flex justify-between items-center">
        <div>
          <h2 className="text-3xl font-bold tracking-tight">Campaigns</h2>
          <p className="text-muted-foreground">Manage your email campaigns</p>
        </div>
        <Button onClick={handleCreateCampaign}>
          <Plus className="w-4 h-4 mr-2" />
          Create Campaign
        </Button>
      </div>

      {campaigns.length === 0 ? (
        <Card>
          <CardContent className="text-center py-12">
            <Mail className="w-16 h-16 mx-auto mb-4 opacity-50" />
            <h3 className="text-lg font-semibold mb-2">No campaigns yet</h3>
            <p className="text-muted-foreground mb-4">
              Create your first email campaign to get started
            </p>
            <Button onClick={handleCreateCampaign}>
              <Plus className="w-4 h-4 mr-2" />
              Create Your First Campaign
            </Button>
          </CardContent>
        </Card>
      ) : (
        <div className="grid gap-4">
          {campaigns.map((campaign: any) => (
            <Card
              key={campaign.id}
              className="cursor-pointer hover:shadow-md transition-shadow"
              onClick={() => handleCampaignClick(campaign.id)}
            >
              <CardHeader>
                <div className="flex justify-between items-start">
                  <div>
                    <CardTitle className="flex items-center gap-2">
                      <Mail className="w-5 h-5" />
                      {campaign.campaignName}
                    </CardTitle>
                    <CardDescription className="mt-1">
                      {campaign.template?.subject || "No subject"}
                    </CardDescription>
                  </div>
                  <Badge variant="default">
                    {campaign.status}
                  </Badge>
                </div>
              </CardHeader>
              <CardContent>
                <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-sm">
                  <div className="flex items-center gap-2">
                    <Users className="w-4 h-4 text-muted-foreground" />
                    <span>
                      {campaign.recipientList ?
                        campaign.recipientList.split(/[,\n]/).filter((email: string) => email.trim()).length : 0
                      } recipients
                    </span>
                  </div>
                  <div className="flex items-center gap-2">
                    <Calendar className="w-4 h-4 text-muted-foreground" />
                    <span>{new Date(campaign.sentAt).toLocaleDateString()}</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <Mail className="w-4 h-4 text-muted-foreground" />
                    <span>{campaign.template?.mailName || "No template"}</span>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
};

export default CampaignsList;
